import React, { useEffect, useState } from "react";
import {
    generateCodeChallengeFromVerifier,
    generateCodeVerifier,
} from "../Utility/SHA256CodeGenerator";
import NotAuthorized from "../NotAuthorized/NotAuthorized";
import Page from "../HomePage/HomePage";
import { useDispatch, useSelector } from "react-redux";
import { fetchAccessToken } from "../Redux/AccessTokenSlice";
import { authLoading } from "../Redux/AccessTokenSlice";
import SpinnerMain from "../Spinner/SpinnerMain";
import CommonError from "../GeneralError/GeneralError";
import { DefaultGroup } from "../Utility/Constants"

const AuthHandler = () => {
    const dispatch = useDispatch();
    const isAuthenticated = sessionStorage.getItem("isAuthenticated");
    const loading = useSelector(state => state.accessToken.loading);
    const tokenError = useSelector(state => state.accessToken.error);
    const [codeChallenge, setCodeChallenger] = useState("");
    const [error, setError] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(authLoading(false));
            return;
        }
        if (error || tokenError) {
            return;
        }
        let codeTemp = "";
        if (window.location.search.includes("code")) {
            codeTemp = window.location.search.split("=")[1];
        }

        const code = new URLSearchParams(window.location.search).get("code");
        const authError = new URLSearchParams(window.location.search).get("error_description");
        const codeVerifier = sessionStorage.getItem("codeVerifier");

        const initiateAuthFlow = async () => {
            const codeVerifier = generateCodeVerifier();
            sessionStorage.setItem("codeVerifier", codeVerifier);

            try {
                const codeChallenge = await generateCodeChallengeFromVerifier(codeVerifier);
                setCodeChallenger(codeChallenge);
                window.location.replace(
                    process.env.REACT_APP_REDIRECT_URI.replace(
                        "redirectUri",
                        window.location.origin + "/home"
                    )
                        .replace("clientId", process.env.REACT_APP_CLIENT_ID)
                        .replace("codeChallenge", codeChallenge)
                );
            } catch (error) {
                setError(true);
                console.error("Error generating code challenge:", error);
                dispatch(authLoading(false));
                return;
            }
        };

        const exchangeCodeForToken = async (code) => {
            try {
                await dispatch(fetchAccessToken(code));
            } catch (error) {
                console.error("Token exchange failed:", error);
                setError(true);
                dispatch(authLoading(false));
                return;
            }
        };

        if (codeTemp && codeVerifier) {
            exchangeCodeForToken(code);
        } else if ((codeTemp === "" || codeChallenge === "") && !sessionStorage.getItem("authFlowStarted")) {
            sessionStorage.setItem("authFlowStarted", "true");
            initiateAuthFlow();
        }
        else if (typeof authError === "string") {
            const sanitizedError = authError.toLowerCase(); // safe to use now

            if (sanitizedError.includes("access_denied")) {
                sessionStorage.setItem("isAuthenticated", "false");
                dispatch(authLoading(false));
                return;
            }
        }

        // else if (authError.includes("access_denied")) {
        //     sessionStorage.setItem("isAuthenticated", false);
        //     //setError(true);
        //     dispatch(authLoading(false));
        //     return;
        // }
    }, [dispatch, isAuthenticated, codeChallenge, error, tokenError]);


    if (loading) return <SpinnerMain />;

    if (error || tokenError) {
        return <CommonError />
    }

     if (!loading && (!isAuthenticated || !(localStorage.getItem("cnsaccess")).includes(DefaultGroup.AuthExt_CNS_READ))) {
         return <NotAuthorized />;
     }

    return <Page />;
};

export default AuthHandler;
